"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.function.name.js");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("element-ui/lib/theme-chalk/src/base.css");

require("element-ui/lib/theme-chalk/src/button.css");

var _button2 = _interopRequireDefault(require("element-ui/lib/button"));

require("element-ui/lib/theme-chalk/src/dialog.css");

var _dialog2 = _interopRequireDefault(require("element-ui/lib/dialog"));

var _debounce = _interopRequireDefault(require("throttle-debounce/debounce"));

var _locale = _interopRequireDefault(require("sk-ui/lib/mixins/locale"));

var _components;

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('transition', {
    attrs: {
      "name": "dialog-fade"
    },
    on: {
      "after-leave": _vm.afterLeave,
      "after-enter": _vm.transitionComplete
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    staticClass: "el-dialog__wrapper",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    },
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) {
          return null;
        }

        return _vm.handleWrapperClick($event);
      }
    }
  }, [_c('div', {
    ref: "dialog",
    staticClass: "el-dialog",
    "class": [{
      'is-fullscreen': _vm.fullscreen,
      'el-dialog--center': _vm.center
    }, _vm.customClass],
    style: _vm._px2rem(_vm.style, 24, []),
    attrs: {}
  }, [_vm.showHeader ? _c('div', {
    staticClass: "el-dialog__header",
    attrs: {}
  }, [_vm._t("title", [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {}
  }, [_vm._v(_vm._s(_vm.title))])], {}), _vm._v(" "), _vm.showClose ? _c('button', {
    staticClass: "el-dialog__headerbtn",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_c('i', {
    staticClass: "el-dialog__close el-icon el-icon-close",
    attrs: {}
  })]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _vm.rendered ? _c('div', {
    staticClass: "el-dialog__body",
    attrs: {}
  }, [_vm._t("default", null, {})], 2) : _vm._e(), _vm._v(" "), _vm.showDefaultFooter || _vm.showCustomFooter ? _c('div', {
    staticClass: "el-dialog__footer",
    attrs: {}
  }, [_vm.showDefaultFooter && !_vm.showCustomFooter ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {}
  }, [_vm.showOkBtn ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.t('sk.confirm')))]) : _vm._e(), _vm._v(" "), _vm.showCancelBtn ? _c('el-button', {
    attrs: {},
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText || _vm.t('sk.cancel')))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.showCustomFooter ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {}
  }) : _vm._e()]) : _vm._e()])])]);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElDialog',
  "extends": _dialog2["default"],
  mixins: [_locale["default"]],
  components: (_components = {}, (0, _defineProperty2["default"])(_components, _button2["default"].name, _button2["default"]), (0, _defineProperty2["default"])(_components, _dialog2["default"].name, _dialog2["default"]), _components),
  props: {
    showDefaultFooter: {
      type: Boolean,
      "default": true
    },
    showOkBtn: {
      type: Boolean,
      "default": true
    },
    showCancelBtn: {
      type: Boolean,
      "default": true
    },
    showCustomFooter: {
      type: Boolean,
      "default": false
    },
    loading: {
      type: Boolean,
      "default": false
    },
    closeOnClickModal: {
      type: Boolean,
      "default": false
    },
    showClose: {
      type: Boolean,
      "default": true
    },
    minWidth: String,
    cancelText: String
  },
  mounted: function mounted() {
    var _this = this;

    _dialog2["default"].mounted && _dialog2["default"].mounted.call(this);
    this.update = (0, _debounce["default"])(10, function () {
      _this.$refs.scroll.update();
    });
    this.$nextTick(function () {
      _this.$el && _this.$el.focus();
    }); // on(window, 'resize', this.offset);
    // this.$nextTick(() => {
    //   this.offset();
    // })
  },
  computed: {
    style: function style() {
      var style = {};

      if (this.width) {
        style.width = this.width;
      }

      if (this.minWidth) {
        style.minWidth = this.minWidth;
      }

      if (!this.fullscreen) {
        style.marginTop = this.top;
      }

      return style;
    },
    dialogPanel: function dialogPanel() {
      return this.$refs.scroll.$el.querySelector('.el-scrollbar__wrap');
    }
  },
  methods: {
    transitionComplete: function transitionComplete() {// this.$refs.scroll.update();
    },
    // offset() {
    //   const wrap = this.$refs.dialog;
    //   const hasScroll = getScroll(this.dialogPanel).scrollY;
    //   const area = [wrap.offsetWidth - (hasScroll ? getScrollBarWidth() : 0), wrap.offsetHeight];
    //   const winArea = this.winArea();
    //   const winW = winArea.width;
    //   const winH = winArea.height;
    //   const offsetTop = (winH - area[1]) / 2;
    //   const offsetLeft = (winW - area[0]) / 2;
    //   this.$refs.dialog.style.left = offsetLeft + 'px';
    //   this.$refs.dialog.style.top = offsetTop < 0 ? 0 : offsetTop + 'px';
    // },
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    },
    handleOk: function handleOk() {
      this.$emit('ok');
    } // handleMouseup() {
    //   // off(document, 'mousemove', this.handleMousemove);
    //   // off(document, 'mouseup', this.handleMouseup);
    // },
    // handleMousemove(event) {
    //   event = event || window.event;
    //   this.move(event, this.disX, this.disY);
    // },
    // handleMousedown(event) {
    //   // event = event || window.event;
    //   // event.preventDefault();
    //   // const oDrag = this.$refs.dialog;
    //   // // 光标按下时光标和面板之间的距离
    //   // this.disX = event.clientX - oDrag.offsetLeft;
    //   // this.disY = event.clientY - oDrag.offsetTop;
    //   // this.hasScroll = getScroll(this.$refs.dialogPanel).scrollY
    //       //   // on(document, 'mousemove', this.handleMousemove);
    //   // // 释放鼠标
    //   // on(document, 'mouseup', this.handleMouseup);
    // },
    // winArea() {
    //   return {
    //     width: document.documentElement.clientWidth || document.body.clientWidth,
    //     height: document.documentElement.clientHeight || document.body.clientHeight
    //   };
    // },
    // move(e, posX, posY) {
    //   const oDrag = this.$refs.dialog;
    //   let l = e.clientX - posX;
    //   let t = e.clientY - posY;
    //   const winArea = this.winArea();
    //   const winW = winArea.width - (this.hasScroll ? getScrollBarWidth() : 0);
    //   const winH = winArea.height;
    //   const maxW = winW - oDrag.offsetWidth;
    //   const maxH = winH - oDrag.offsetHeight;
    //   if (l < 0) {
    //     l = 0;
    //   } else if (l > maxW) {
    //     l = maxW;
    //   }
    //   if (t < 0) {
    //     t = 0;
    //   } else if (t > maxH) {
    //     t = maxH;
    //   }
    //   oDrag.style.left = l + 'px';
    //   oDrag.style.top = t < 0 ? 0 : t + 'px';
    // }

  },
  beforeDestroy: function beforeDestroy() {
    _dialog2["default"].beforeDestroy && _dialog2["default"].beforeDestroy.call(this); // off(document, 'mousemove', this.handleMousemove);
    // off(document, 'mouseup', this.handleMouseup);
    // off(window, 'resize', this.update);
  }
};
exports["default"] = _default;